import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Title, Note } from 'components/misc'
import styles from './empty-dashboard.styl'

import iconPhysical from 'assets/img/activities/icon-physical-big.svg'
import iconSkills from 'assets/img/activities/icon-skills-big.svg'
import iconService from 'assets/img/activities/icon-service-big.svg'
import iconAj from 'assets/img/activities/icon-aj-big.svg'
import iconResidental from 'assets/img/activities/icon-residental-big.svg'

const icons = [
  iconPhysical,
  iconSkills,
  iconService,
  iconAj,
  iconResidental
]

class EmptyDashboard extends PureComponent {
  static propTypes = {
    notApproved: PropTypes.bool,
    isLoading: PropTypes.bool,
    isAssessor: PropTypes.bool
  }

  render() {
    const { notApproved, isLoading, isAssessor } = this.props

    if (isLoading) {
      return <div />
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.images}>
          {icons.map(path => <img key={path} src={path} />)}
        </div>
        <Title h1 intlKey="moduleTitle.welcome_to_orb">
          Welcome to Online Record Book
        </Title>

        {!isAssessor && (
          <div>
            {notApproved ? (
              <Note fontSize="1.6rem" intlKey="empty_dashboard.not_approved">
                This tool will help you record your progress during your Award.
                But your profile is not approved yet by your Award Leader.
                Before you start creating your first activity, you will have to
                wait for the approval.
              </Note>
            ) : (
              [
                <Note
                  key="approved_1"
                  fontSize="1.6rem"
                  intlKey="empty_dashboard.approved_1"
                >
                  This tool will help you record your progress during your
                  Award.
                </Note>,
                <Note
                  key="approved_2"
                  fontSize="1.6rem"
                  intlKey="empty_dashboard.approved_2"
                >
                  First you have to set up your an activity. To start, click on
                  one of the left. If you need some help with activity setup,
                  ask your Award Leader for assistance.
                </Note>
              ]
            )}
          </div>
        )}
      </div>
    )
  }
}

export default EmptyDashboard
